import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/api/auth'
// import crypto from 'crypto'

const domains = window.location.host.split('.')
const requestQueue = {}

// eslint-disable-next-line no-unused-vars
function handleRequest(config) {
  console.log(config)
  // const md5 = crypto.createHash('md5')
  // 往hash对象中添加摘要内容
  // md5.update(config.url + (config.param ? JSON.stringify(config.param) : '') + (config.data ? JSON.stringify(config.data) : ''))
  // const requestId = md5.digest('hex')

  // if (requestQueue[requestId] && requestQueue[requestId] === 1) {
  //   return false
  // }
  // requestQueue[requestId] = 1
  // setTimeout(function () {
  //   requestQueue[requestId] = 0
  // }, 300)
  return true
}
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API == '' ? ('https://api.' + domains[domains.length-2] + '.' + domains[domains.length-1]) : process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 120
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (getToken()) {
      config.headers['ApiToken'] = getToken()
    }
    // if (!handleRequest(config)) {
    //   return Promise.reject(new Error('数据操作太频繁提交过快'))
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    // res.code = 401
    if (res.code == 401) {
      // 这里需要做区分的处理，如果是一一开始getInfo 的操作
      console.log(store.state)
      store.dispatch('resetToken').then(() => {
        store.state.loginOpen = true
        return res
      })
    } else if (res.code !== 200) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
